import React, { useEffect, useState, useContext, Fragment } from "react";
import SharedDataContext from "../../_helper/SharedData";
import {
    showAlert,
} from "../../Services/Shared.service";
import { Breadcrumbs, Btn, H4, H6 } from "../../AbstractElements";
import { Row, Col, Card, CardBody, Container, Modal, ModalBody, Nav, NavItem, NavLink } from "reactstrap";
import { Plus } from "react-feather";
import { getRatesList } from "../../Services/Rates.service";
import RatesTable from "./RatesTable";
import RateInput from "./RateInput";
import RateCalendar from "./RateCalendar";
import { CalendarViewFunctions } from "./Components/CalendarViewFunctions";
import { endOfMonth, startOfMonth } from "date-fns";

const calendarViewFunctions = new CalendarViewFunctions()

const Rates = ({serviceCityId}) => {
    const { cityData, globalCityField, setShowApiLoader, airportData } =
        useContext(SharedDataContext);
    const [tableData, setTableData] = useState([]);
    const [loader, setLoader] = useState(false);
    const [paginationTotalRows, setPaginationTotalRows] = useState(0);
    const [isOpen, setIsOpen] = useState(false);
    const [editId, setEditId] = useState("")
    const [pagination, setPagination] = useState({
        pageIndex: 0,
        pageSize: 30,
    });
    const [isToggled, setIsToggled] = useState(false)
    const [calendarData, setCalendarData] = useState([])
    const [tableHeaders,setTableHeaders] = useState([])

    console.log("wewewewe",startOfMonth(new Date()))

    const onChangePage = (page) => {
        console.log("page", page);
        setPagination({
            ...pagination,
            pageIndex: page - 1
        });
    };

    const onChangeRowsPerPage = (currentRowsPerPage) => {
        setPagination({
            ...pagination,
            pageSize: currentRowsPerPage
        });
    };

    useEffect(() => {
        fetchTableData(serviceCityId);
    }, [globalCityField.value, pagination.pageIndex, pagination.pageSize]);

    const fetchTableData = (serviceCityId) => {
        // const serviceCityId = globalCityField.value?.id || null;
        let obj = {
            serviceCityId: serviceCityId,
            page: pagination.pageIndex,
            size: pagination.pageSize,
        };
        setLoader(true);
        getRatesList(obj)
            .then(async (result) => {
                setPaginationTotalRows(result.data.count);
                console.log("result1233 is ",result)
                setTableData(result.data.list);
                console.log("rates data is",tableData)
                setCalendarData(await calendarViewFunctions.getCalendarData(result.data.list, onEditClick, false, startOfMonth(new Date()),endOfMonth(new Date())))
                setTableHeaders(await calendarViewFunctions.getTableHeader(startOfMonth(new Date()), endOfMonth(new Date())))
                disableLoaders();
            })
            .catch((err) => {
                disableLoaders();
                showAlert("error", err.response?.data?.message
                    ? err.response.data.message : "Something went wrong");
            });
    };
    const disableLoaders = () => {
        setLoader(false);
        // setShowApiLoader(false);
    };

    const onEditClick = (element) => {
        setEditId(element.id)
        setIsOpen(true)
    }

    console.log("calendar data",calendarData)

    return (
        <Fragment>
            {/* <Breadcrumbs
                parent="Configuration"
                subParent="Rates"
                mainTitle="Rates"
                span1={
                    <div style={{ display: "flex", justifyContent: "center", alignItems: "end" }}>
                        <i className="fa fa-table" onClick={() => setIsToggled(false)} style={{ fontSize: "28px", marginBottom: "5px", cursor: "pointer" }}></i>
                        <div className="custom-toggle-switch" style={{ margin: "0px 10px" }}>
                            <input
                                type="checkbox"
                                checked={isToggled ? true : false}
                                onChange={(e) => {
                                    setIsToggled(!isToggled)
                                }}
                                id={"switch"}
                            />
                            <label htmlFor="switch"></label>
                        </div>
                        <i className="fa fa-calendar" onClick={() => setIsToggled(true)} style={{ fontSize: "25px", marginBottom: "8px", cursor: "pointer" }}></i>
                    </div>
                }
                span3={
                    <Btn attrBtn={{ style: { display: "flex", padding: "7px 14px", justifyContent: "center", alignItems: "center" }, onClick: (e) => setIsOpen(true) }}>
                        <Plus size={"18px"} style={{ marginRight: "5px" }} /> Add
                    </Btn>
                }
            /> */}
            <Container fluid={true} className="datatables">
                <Row>
                    <Col sm="12">
                        <Card>
                            <CardBody className="p-0">
                                {/* {isToggled ?
                                    ( */}
                                    <RateCalendar
                                        ratesData={tableData}
                                        calendarData={calendarData}
                                        setCalendarData={setCalendarData}
                                        tableHeaders={tableHeaders}
                                        setTableHeaders={setTableHeaders}
                                        pagination={pagination}
                                        setPagination={setPagination}
                                        paginationTotalRows={paginationTotalRows}
                                        onEditClick={onEditClick} 
                                        loader={loader}
                                        />
                                        {/* )
                                    :
                                    (<RatesTable
                                        fetchTableData={fetchTableData}
                                        tableData={tableData}
                                        setShowApiLoader={setLoader}
                                        onChangePage={onChangePage}
                                        paginationPerPage={pagination.pageSize}
                                        paginationTotalRows={paginationTotalRows}
                                        onChangeRowsPerPage={onChangeRowsPerPage}
                                        onEditClick={onEditClick}
                                        loader={loader}
                                    />)} */}
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Container>
            <RateInput cityData={cityData} airportData={airportData} editId={editId} setIsOpen={setIsOpen} fetchTableData={fetchTableData} isOpen={isOpen} setEditId={setEditId} />
        </Fragment>
    );
};

export default Rates;
